import React from 'react'

export default function Loader() {
  return (
    <div className='loderWrp'>
      <img className='img-fluid' src='/assets/img/loder.gif' alt='#' />
    </div>
  )
}
